
import { useSelector } from "react-redux"

import { Routes, Route } from "react-router"

import { HomePage } from "../pages/HomePage"

import { NotFoundPage } from "../pages/auth/NotFoundPage"

import { AdministracionPage } from "../pages/admin/AdministracionPage"
import { ApiKeysPage } from "../pages/admin/ApiKeysPage"
import { UsuariosPage } from "../pages/admin/UsuariosPage"

import { TipoUsuarioPage } from "../pages/catalogos/TipoUsuarioPage"
import { EstatusPage } from "../pages/catalogos/EstatusPage"
import { RootState } from "../store"
import { AutoridadPage } from "../pages/catalogos/AutoridadPage"
import { PuestoPage } from "../pages/catalogos/PuestoPage"
import { MateriaPage } from "../pages/catalogos/MateriaPage"
import { DistritoJudicialPage } from "../pages/catalogos/DistritoJudicialPage"
import { SalaPage } from "../pages/catalogos/SalaPage"
import { TipoAudienciaPage } from "../pages/catalogos/TipoAudienciaPage"
import { TipoSesionPage } from "../pages/catalogos/TipoSesionPage"
import { CalendarioPage } from "../pages/admin/CalendarioPage"

export const AudienciasRoutes = () => {

    const { administrador, token } = useSelector( ( state: RootState ) => state.auth );

    return (

        <Routes>

            {
                administrador
                ?
                    <>

                        <Route path="/" element={ <AdministracionPage /> } />   
                        
                        <Route path="/administracion/usuarios" element={ <UsuariosPage /> } />   
            
                        <Route path="/administracion/apikeys" element={ <ApiKeysPage /> } />    
            
                        <Route path="/administracion/calendario" element={ <CalendarioPage /> } />   
            
                        <Route path="/administracion/catalogos/tipo-usuario" element={ <TipoUsuarioPage /> } />    
            
                        <Route path="/administracion/catalogos/estatus" element={ <EstatusPage /> } />    

                        <Route path="/administracion/catalogos/puesto" element={ <PuestoPage /> } />    

                        <Route path="/administracion/catalogos/autoridad" element={ <AutoridadPage /> } />    

                        <Route path="/administracion/catalogos/materia" element={ <MateriaPage /> } />    

                        <Route path="/administracion/catalogos/distrito-judicial" element={ <DistritoJudicialPage /> } />    

                        <Route path="/administracion/catalogos/sala" element={ <SalaPage /> } />    

                        <Route path="/administracion/catalogos/tipo-audiencia" element={ <TipoAudienciaPage /> } />    

                        <Route path="/administracion/catalogos/tipo-sesion" element={ <TipoSesionPage /> } />    
                    
                    </>
                :
                    <Route path="/" element={ <HomePage /> } />   
            }    
            
            {
                token && <Route path="*" element={ <NotFoundPage /> } />
            }

        </Routes>        
    
    )
}